import React, { FC, useState } from 'react';
//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';
import { useDispatchPromise } from 'hooks/useDispatchPromise';
import { driverSalaryAdjustmentsDetailDelete } from 'bus/driverSalaryAdjustments/actions';

type Props = {
    id: number | null;
    visible: boolean;
    changeVisible: (visible: boolean) => void
    refresh: () => void
}

const DeleteModal: FC<Props> = ({
    changeVisible,
    id,
    refresh,
    visible
}) => {
    const dispatch = useDispatchPromise();
    const [loading, setLoading] = useState(false);
    
    const handleSubmit = async (e: any) => {
        setLoading(true);
        e.preventDefault && e.preventDefault()
        await dispatch(driverSalaryAdjustmentsDetailDelete.async({ id: id! }));
        refresh();
        changeVisible(false);
        setLoading(false);
    }

    return (
        <div>
            <Popup
                visible={visible}
                onHiding={() => changeVisible(false)}
                dragEnabled={true}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Подтвердите действие"
                width={400}
                height={160}
            >
                <div className="modal-block">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-block__content">
                            Вы действительно хотите удалить?      
                        </div>

                        <ModalFooter
                            useSubmitBehavior={false}
                            handleSubmit={handleSubmit}
                            hideModal={() => changeVisible(false)}
                            textConfirm="Удалить"
                            typeConfirm="danger"
                            disabledSubmit={loading}
                        />
                    </form>      
                </div>
            </Popup>
        </div>
    )
}

export default DeleteModal;